<template>
    <v-dialog
        v-model="addNoteDialog"
        hide-overlay
        width="500"
        scrollable
        :fullscreen="this.$vuetify.breakpoint.xsOnly"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-show="!rowid"
                class="ma-1 text-subtitle-2"
                outlined
                light
                v-bind="attrs"
                @click="openModel"
            >
                <v-icon>mdi-upload-outline</v-icon>
                Add Note
            </v-btn>
            <v-icon
                v-show="rowid"
                class="mr-2"
                v-bind="attrs"
                @click="openModel"
            >
                mdi-pencil-outline
            </v-icon>
        </template>
        <v-card id="addNote">
            <v-card-title class="text-h5 lighten-2">
                <span>{{ rowid ? 'Edit' : 'Add' }} Notes</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <v-form
                    ref="form"
                    v-model="addNoteForm"
                >
                    <div class="text-area">
                        <label>Note</label>
                        <v-textarea
                            v-model="ticketNote"
                            :style="{'height': this.$vuetify.breakpoint.xsOnly ? '255px' : '', 'max-height': this.$vuetify.breakpoint.xsOnly ? '255px' : '',}"
                            outlined
                            counter="4000"
                            label="Enter Note"
                            :rules="[rules.length(4000)]"
                        />
                    </div>
                </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    :style="{'width': this.$vuetify.breakpoint.xsOnly ? '50%' : ''}"
                    outlined
                    light
                    @click="closedModel"
                >
                    Cancel
                </v-btn>
                <v-btn
                    v-if="!rowid"
                    style="text-transform: none !important"
                    :style="{'width': this.$vuetify.breakpoint.xsOnly ? '50%' : ''}"
                    depressed
                    color="primary"
                    :disabled="!addNoteForm || !ticketNote"
                    @click="save"
                >
                    Add
                </v-btn>
                <v-btn
                    v-if="rowid"
                    style="text-transform: none !important"
                    :style="{'width': this.$vuetify.breakpoint.xsOnly ? '50%' : ''}"
                    depressed
                    color="primary"
                    :disabled="!addNoteForm || !ticketNote"
                    @click="edit"
                >
                    Edit
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {
    props: {
        rowid: {
            type: String,
            required: false,
            default: null,
        },
        ticketnote: {
            type: String,
            required: false,
            default: null,
        },
    },
    data: () => ({
        addNoteForm: false,
        addNoteDialog: false,
        ticketNote: null,
        rules: {
            length: len => v => (v || '').length <= len || `Maximum ${len} character allowed`,
        },
    }),
    methods: {
        closedModel() {
            this.addNoteDialog = false;
            this.ticketNote = null;
        },
        openModel() {
            this.addNoteDialog = true;
            if(this.ticketnote) {
                this.ticketNote = this.ticketnote;
            }
        },
        async save() {
            let request = {
                oper: 'insert',
                ticket_note: this.ticketNote,
                tid: this.$route.query.tid,
                __TIMESTAMP__: new Date().getTime(),
            };
            let response = await webtmsBackend.addNote(request);
            if(response.result == 'OK') {
                this.$emit('load-ticket-details');
                this.closedModel();
            }
        },
        async edit() {
            let request = {
                oper: 'update',
                ticket_note: this.ticketNote,
                rowid: this.rowid,
                __TIMESTAMP__: new Date().getTime(),
            };
            let response = await webtmsBackend.addNote(request);
            if(response.result == 'OK') {
                this.$emit('load-ticket-details');
                this.closedModel();
            }
        }
    }
};
</script>
<style>
    #addNote .text-area {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-top: 15px;
    }
    #addNote .v-textarea {
        margin-top: 10px;
    }
</style>